import { render } from "./EnAbout.vue?vue&type=template&id=9261c3b4&scoped=true"
const script = {}

import "./EnAbout.vue?vue&type=style&index=0&id=9261c3b4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-9261c3b4"

export default script